// extracted by mini-css-extract-plugin
module.exports = {"digitalWalletBtn":"DigitalWalletButton_digitalWalletBtn__2vesf","paymentLogo":"DigitalWalletButton_paymentLogo__WL09v"};